import SymbolAnim from "../symbols/SymbolAnim"
import {STATES} from "../../framework/src/states/states";
// import MadmaxCommanderBase from "../../framework/src/madmax/MadmaxCommanderBase";
/**
 * Location: (framework)../src/win/WinController.js
 * Location: (game)src/win/WinController.js
 *
 * This class handles the result. If any win appears, the win animation are started.
 *
 * @property commander {Commander}
 * @property win {number} current win amount
 * @property winLines {array} array of winLines from result
 * @property line {array} current winLine
 * @property reelMatrix {array} array of current symbol values (from result.reelMatrix)
 * @property result {Object} parsed response from server, represents the result of current round
 * @property resSymbols {array} array of result symbols
 * @class
 */
class WinController {
    constructor (commander){
        this.commander = commander;
        this.win = 0;
        this.winLines = [];
        this.line = {};
        this.reelMatrix = [];
        this.result = {};
        this.resSymbols = [];

        this.winSymbols = [
            [false,false,false],
            [false,false,false],
            [false,false,false],
            [false,false,false]
        ];

        this.skip = false;
    }

    init() {
    }

    /**
     * Called after every round, initializes the class properties with values from result.
     * Calls {@link WinController#lineWins} to animate win.
     * Returns a Promise that ends after the last line win.
     * @param result
     * @return {Promise<any>}
     */
    async run (result) {
        this.commander.states.setState(STATES.SKIP);
        this.result = result;
        this.reelMatrix = result.reelMatrix;
        this.win = result.win;
        this.winLines = result.lineWins;
        this.resSymbols = this.commander.slots.getResultSymbols();
        this.drawWinSymbols();
        await this.lineWins(this.winLines);
    }


    /**
     * Iterate through winlines and run animation for each line.
     * Calls {@link WinController#animLine}
     * @param winLines {array} result.lineWins.
     * @return {Promise<any>}
     */
    lineWins(winLines){
        return new Promise (res => {
            if (winLines.length > 0){
                let line = winLines.shift();
                this.animLine(line, winLines, res);
            }
        });
    }

    /**
     * This method recursively calls itself. It pops a line from winLines array, iterates through winLine.position and
     * runs the animation for every symbol. Returns a promise after the animation ends. If there are no more lines, call
     * the callback() to end the win animation.
     * @param line {array} current winLine
     * @param winLines {array} remaining winLines
     * @param callback
     */
    animLine(line, winLines, callback){
        if (winLines.length === 0 && line === undefined) {
            this.commander.symbolAnim.lightenReels();
            callback();
        } else {
            new Promise(res => {
                let promises = [];
                let long = false;
                if (line.symbol >= 5) {
                    long = true;
                    this.commander.audio.playTrack("win_High");
                } else {
                    this.commander.audio.playTrack("win_Low");
                }
                this.commander.addWin(line.win*line.multiplier);

                for (let pos of line.position) {
                    let symbol = this.resSymbols[pos[0] * 3 + pos[1]];
                    // Symbol.animateSymbol(symbol, loop) => loop {number} count of loops between start & end (0 by default)
                    promises.push(this.commander.symbolAnim.animateSymbol(symbol, line.multiplier, long));
                }
                Promise.all(promises).then(() => {
                    res();
                });
            }).then(() => {
                let line = winLines.shift();
                this.commander.symbolAnim.cleanup();
                if (this.skip) {
                    this.skip = false;
                    this.commander.symbolAnim.lightenReels();
                    callback();
                } else {
                    this.animLine(line, winLines, callback);
                }
            });
        }
    }

    /**
     * Iterate throough lineWins and every position.
     * Sets value true to this.winSymbols array for every position.
     * After execution, this.winSymbols contains values true on every symbol that is on a winning line.
     * @param result {Object} response from server
     */
    setWinSymbols(result) {
        for(let lineWin of result.lineWins) {
            for(let pos of lineWin.position) {
                this.winSymbols[pos[0]][pos[1]] = true;
            }
        }
    }

    /**
     * Remove all sprites from layer. Set value false to every variable in array this.winSymbols.
     * Set original reel symbols to visible again.
     */
    removeWinSymbols() {
        this.commander.layers.winSymbols.removeChildren();
        this.winSymbols = [
            [false,false,false],
            [false,false,false],
            [false,false,false],
            [false,false,false]
        ];
        for (let symbol of this.resSymbols) {
            symbol.visible = true;
        }
    }

    /**
     * Iterate through this.winSymbols and create a sprite of that symbol, set its position and
     * add it to layer. Hide the original symbol in the process.
     */
    drawWinSymbols() {
        for (let i = 0; i < 4; i++)
            for (let j = 0; j < 3; j++) {
                if (this.winSymbols[i][j] === true) {
                    this.resSymbols[i*3+j].visible = false;
                    this.commander.layers.winSymbols.addChild(
                        this.commander.winSymbolSprites[i][j] = SymbolAnim.createSprite(
                            this.resSymbols[i*3+j].x,
                            this.resSymbols[i*3+j].y,
                            this.resSymbols[i*3+j].name+".png"
                        )
                    );
                }
            }
    }
}
export default WinController;